import React from "react";
import styles from "./LoadingStory.module.scss";

const LoadingStory = (props) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.track}>
        <div className={`${styles.puckGroup} ${styles.puckGroupLeft}`}>
          <img src={"./img/loading-pink-puck.svg"} alt="" className={styles.puck} draggable={false} />
        </div>
        <div className={`${styles.puckGroup} ${styles.puckGroupRight}`}>
          <img src={"./img/loading-blue-puck.svg"} alt="" className={styles.puck} draggable={false} />
        </div>
      </div>
    </div>
  );
};

export default LoadingStory;
